/**
 * sync a variable with the router.
 */
export const syncRoute = (
    variable: MaybeRefOrGetter<Readonly<any>>,
    param: MaybeRefOrGetter<Readonly<string>>,
    additionalQueryParams: MaybeRefOrGetter<Readonly<object>> = {}
) => {
    const router = useRouter();
    const route = useRoute();

    watch (() => toValue(variable), () => {
        router.push({
            query: {
                ...route?.query ?? {},
                [toValue(param)]: toValue(variable) || null,
                ...additionalQueryParams
            }
        });
    });
};
